<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { Checkbox } from 'primevue';
import { useListManageDashboardComponentTypeConfigApi } from '../api/listManageDashboardComponentTypeConfigApi';
import type { DashboardComponentTypeConfigResponse } from '../models/DashboardComponentTypeConfigResponse';
import { useToggleDashboardComponentTypeConfigApi } from '../api/toggleDashboardComponentTypesConfigApi';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';

const listManageDashboardComponentTypeConfigApi = useListManageDashboardComponentTypeConfigApi();
const toggleDashboardComponentTypeConfigApi = useToggleDashboardComponentTypeConfigApi();
const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

//hämtar in och gör en reaktiv variabel som lyssnar på förändringar, uppbyggd enligt interfacestrukturen
const dashboardComponentTypeConfigs = ref<DashboardComponentTypeConfigResponse[]>([]);

//hämtar in när sidan laddas
onMounted(async () => {
  dashboardComponentTypeConfigs.value = await listManageDashboardComponentTypeConfigApi.execute();
});

async function toggleDashboardComponentTypeConfig(dashboardComponentTypeConfig: DashboardComponentTypeConfigResponse) {
  //hämtar in värdet true/false på komponenttypen
  const booleanValue = Boolean(dashboardComponentTypeConfig.enabled);
  //väntar in svaret från apiet
  await toggleDashboardComponentTypeConfigApi.execute({
    dashboardComponentType: dashboardComponentTypeConfig.dashboardComponentType,
    enabled: booleanValue,
  });
}
</script>
<template>
  <div>
    <div
      v-for="dashboardComponentType in dashboardComponentTypeConfigs"
      :key="dashboardComponentType.dashboardComponentType"
      class="feature-flag"
    >
      <div class="mt-2">
        <Checkbox
          v-model="dashboardComponentType.enabled"
          @change="() => toggleDashboardComponentTypeConfig(dashboardComponentType)"
          class="me-2"
          size="small"
          binary
        />
        <label>{{
          translations.enums.dashboardComponentType(dashboardComponentType.dashboardComponentType)
        }}</label>
      </div>
    </div>
  </div>
</template>
